import { render } from "./RequiredWarning.vue?vue&type=template&id=401829a1&scoped=true"
import script from "./RequiredWarning.vue?vue&type=script&lang=js"
export * from "./RequiredWarning.vue?vue&type=script&lang=js"

import "./RequiredWarning.vue?vue&type=style&index=0&id=401829a1&scoped=true&lang=css"

import exportComponent from "/var/www/greenified-mono-staging/ims.greenified.se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-401829a1"]])

export default __exports__